import { useState, useEffect, useCallback } from 'react';

export function useFormPersist(key, initialState) {
  const [state, setState] = useState(() => {
    try {
      const saved = localStorage.getItem(`form_${key}`);
      return saved ? JSON.parse(saved) : initialState;
    } catch {
      return initialState;
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(`form_${key}`, JSON.stringify(state));
    } catch {}
  }, [key, state]);

  const clearForm = useCallback(() => {
    localStorage.removeItem(`form_${key}`);
    setState(initialState);
  }, [key, initialState]);

  return [state, setState, clearForm];
}
